
'format es6';

import $ from 'jquery';
import gsap from 'greensock';
import Store from 'store';
import User from '../User';
import { factory as sectionFactory } from './Section';

require('magnific-popup');
require('../../views-compiled/instructions');

const EASING = gsap.Expo;

function Instructions() {

	this.templateName = 'instructions.htm';

	let cta;

	this.setAnimation = (tl, rootNode, setInEndTime) => {
		tl.from(rootNode, 0.3, { opacity: 0, ease: EASING.easeIn });
		const animateInFinish = setInEndTime();
		tl.to(rootNode, 0.3, { opacity: 0, ease: EASING.easeOut }, animateInFinish);
		return tl;
	};

	this.popInstructions = () => {
		const isReturning = User.get('instructions_shown') ? User.get('instructions_shown').shown : false;

		if (!isReturning) {
			User.set('instructions_shown', { shown: true });

			//$.magnificPopup.open({
			//	items: {
			//		src: '#instructions-popup',
			//	},
			//	type: 'inline',
			//});

			$('#close-instructions').on('click.udem', () => {
				$.magnificPopup.close();
			});
		}
	};

	this.activate = () => {
		this.popInstructions();

		cta = $('[data-cta-continue]', this.sectionNode);
		cta.on('click.cursus', (e) => {
			e.preventDefault();
			this.animateOut().then(() => {
				this.next && this.next();
			});
		});
	};

	this.deactivate = () => {
		cta && cta.off('.cursus');
	};

	return this;
}


export function factory(instance) {
	return Instructions.call(sectionFactory(instance || {}));
}
